import CoinbaseIcon from "../../../components/Icons/Wallets/Coinbase"
import Phantom from "../../../components/Icons/Wallets/Phantom"
import Solflare from "../../../components/Icons/Wallets/Solflare"
import WalletConnectIcon from "../../../components/Icons/Wallets/WalletConnect"

const KnownSolanaConnectors = [
    {
        id: 'solflare',
        icon: Solflare
    },
    {
        id: 'phantom',
        icon: Phantom
    },
    {
        id: 'walletconnect',
        icon: WalletConnectIcon
    },
    {
        id: 'coinbase',
        icon: CoinbaseIcon
    }
]

export default KnownSolanaConnectors